export function humanizeReason(reason: string): string {
  switch (reason) {
    case 'NotInDictionary': return 'нужно существительное';
    case 'LetterOrderMismatch': return 'неверный порядок букв';
    case 'TooShort': return 'слишком короткое';
    case 'AlreadySubmitted': return 'уже отправлено';
    case 'InvalidCharacters': return 'недопустимые символы';
    default: return reason;
  }
}
